import request from '@/utils/request'

export function qryReturnCoin(params) {
  return request({
    url: '/api/financeInfo/qryUserReturnCoin',
    method: 'post',
    params

  })
}
export function verifyPass(data) {
  return request({
    url: '/api/financeInfo/userReturnCoinVerifyPass',
    method: 'post',
    data

  })
}
export function verifyNoPass(data) {
  return request({
    url: '/api/financeInfo/userReturnVerifyNoPass',
    method: 'post',
    data

  })
}
export function verifyDone(params) {
  return request({
    url: '/api/financeInfo/userReturnCoinVerifyDone',
    method: 'post',
    params

  })
}

export function exportExcel(params) {
  return request({
    url: '/api/financeInfo/exportUserReturnCoin',
    method: 'post',
    params
  })
}
